/* qeslint-disable */
// q@ts-nocheck

export enum AreaUnits {
    SQUARE_METERS = "SQUARE_METERS",
    SQUARE_CENTIMETERS = "SQUARE_CENTIMETERS",
    SQUARE_KILOMETERS = "SQUARE_KILOMETERS",
    SQUARE_FEET = "SQUARE_FEET",
    SQUARE_INCHES = "SQUARE_INCHES",
    SQUARE_YARDS = "SQUARE_YARDS",
    SQUARE_MILES = "SQUARE_MILES",
    ACRES = "ACRES",
    HECTARES = "HECTARES"
}
